type CustomParams = {
  [key: string]: unknown;
};
type Callback = () => void;

export function useTracker() {
  const route = useRoute();
  const { getJourneyContext } = useUserJourney();

  function getUtmParams(): CustomParams {
    return Object.fromEntries(
      Object.entries(route.query)
        .filter(([key]) => key.startsWith('utm_'))
        .map(([key, value]) => [key, value ?? null]),
    );
  }

  function getJourneyTrackingParams(): CustomParams {
    const context = getJourneyContext();

    return {
      journey_id: context.journey_id,
      is_personification: context.is_personification,
      ...(context.partner_id != null ? { partner_id: context.partner_id } : {}),
    };
  }

  const trackGTMEvent = (event: string, data?: CustomParams) => {
    if (typeof window === 'undefined') return;

    window.dataLayer?.push({ ecommerce: null });
    window.dataLayer?.push({
      event,
      eventCategory: 'ecommerce',
      ...getJourneyTrackingParams(),
      ...getUtmParams(),
      ...data,
    });
  };

  function track(eventName: string, data?: CustomParams, callback?: Callback) {
    const eventParams = {
      ...getJourneyTrackingParams(),
      ...getUtmParams(),
      ...data,
    };

    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', eventName, eventParams);
    }

    if (callback) callback();
  }

  function setUserProperties(properties: CustomParams) {
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('set', 'user_properties', properties);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'set_user_properties',
        user_properties: {
          ...properties,
        },
      });
    }
  }

  return {
    track,
    setUserProperties,
    trackGTMEvent,
    getJourneyTrackingParams,
    getUtmParams,
  };
}
